import React, { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTermsAccaAgree } from '@components/accaAgree/query/useTerms';
import ResultModal, { ContentType } from '@components/accaAgree/resultModal';

const AccaAgree: FC = () => {
  const { isReady, query } = useRouter();
  const [resultModalVisible, setResultModalVisible] = useState(false);
  const [contentType, setContentType] = useState<ContentType>('ERROR');

  const onSuccessAgree = (result: boolean) => {
    if (result) {
      setContentType('SUCCESS');
    } else {
      setContentType('ERROR');
    }

    setResultModalVisible(true);
  };

  const onErrorAgree = (code: string) => {
    if (code === 'B902') {
      setContentType('ALREADY_AGREED');
    } else {
      setContentType('ERROR');
    }

    setResultModalVisible(true);
  };

  const { mutate: termsAccaAgreeMutate } = useTermsAccaAgree(onSuccessAgree, onErrorAgree);

  const onAgree = (id: string) => {
    termsAccaAgreeMutate(id);
    return;
  };

  useEffect(() => {
    if (isReady) {
      onAgree(query.id?.toString() ?? '');
    }
  }, [isReady]);

  return (
    <>
      <ResultModal visible={resultModalVisible} contentType={contentType} />
    </>
  );
};

export default AccaAgree;
